import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ExternalLayoutRoute } from "./components/Navigation/ExternalLayout";
import { LayoutRoute } from "./components/Navigation/Layout";
import { PrinterFriendlyLayoutRoute } from "./components/PrinterFriendlyLayout";
import { PrinterFriendlyConfirmationReceiptLayoutRoute } from "./components/PrinterFriendlyConfirmationReceiptLayout";
import { Login } from "./components/Login";
import ResetPassword from "./components/ResetPassword";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import ContractPaymentHistory from "./components/ContractPaymentHistory";
import ContractSearch from "./components/ContractSearch";
import ContractDetails from "./components/ContractDetails";
import ContractDisbursementQuoteRequest from "./components/ContractDisbursementQuoteRequest";
import ContractDisbursementQuote from "./components/ContractDisbursementQuote";
import ContractDocuments from "./components/ContractDocuments";
import ContractCommissionsApproval from "./components/Commissions/ContractCommissions/ContractCommissions";
import CustomerProfile from "./components/CustomerProfile";
import Reports from "./components/Reports";
import OnDemandReportRequest from "./components/OnDemandReportRequest";
import ImpersonateUser from "./components/ImpersonateUser";
import CombinedDetails from "./components/CombinedDetails";
import CombinedContractDisbursementQuote from "./components/CombinedContractDisbursementQuote";
import CombinedContractDisbursementQuoteRequest from "./components/CombinedContractDisbursementQuoteRequest";
import PaymentHistory from "./components/PaymentHistory";
import ContractDetailsPrint from "./components/ContractDetailsPrint";
import ConfirmationReceiptPrint from "./components/ConfirmationReceiptPrint";
import ConfirmationReceiptPurchaserPrint from "./components/ConfirmationReceiptPurchaserPrint";
import CombinedDetailsPrint from "./components/CombinedDetailsPrint";
import CoupLetterPrint from "./components/CoupLetterPrint";
import SocialSecurityLetterPrint from "./components/SocialSecurityLetterPrint";
import Unauthorized from "./lib/components/Unauthorized";
import withClearCache from "./higherOrderComponents/ClearCache";
import Forms from "./components/Forms";
import "./components/clearpoint.css";
import Payment from "./components/Payment";
import UploadPage from "./components/DocumentUpload/UploadPage";
import Dashboard from "./components/Dashboard";
import PayoutRuns from "./components/Commissions/Approvals/PayoutRuns";
import PayoutRun from "./components/Commissions/Approvals/PayoutRun";

const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}

function MainApp() {
  return (
    <BrowserRouter basename={"/"}>
      <ExternalLayoutRoute path="/login" component={Login} />
      <ExternalLayoutRoute path="/reset-password" component={ResetPassword} />
      <ExternalLayoutRoute path="/signup" component={Signup} />
      <ExternalLayoutRoute path="/forgot-password" component={ForgotPassword} />
      <LayoutRoute exact path="/" component={Dashboard} />
      <LayoutRoute path="/home" component={Dashboard} />
      <LayoutRoute path="/payment" component={Payment} />
      <LayoutRoute path="/contracts" component={ContractSearch} />
      <LayoutRoute path="/dashboard" component={Dashboard} />
      <LayoutRoute path="/commissions-contracts" component={ContractCommissionsApproval} />
      <LayoutRoute path="/commissions-payout-runs" component={PayoutRuns} />
      <LayoutRoute path="/commissions-payout-runs/:payoutRunId" component={PayoutRun} />
      <LayoutRoute
        path="/contract-payment-history"
        component={ContractPaymentHistory}
      />
      <LayoutRoute
        exact
        path="/contracts/:number"
        component={ContractDetails}
      />
      <LayoutRoute
        path="/contracts/:number/disbursement-quote-request"
        component={ContractDisbursementQuoteRequest}
      />
      <LayoutRoute
        path="/contracts/:number/disbursement-quote"
        component={ContractDisbursementQuote}
      />
      <LayoutRoute
        path="/contracts/:number/documents"
        component={ContractDocuments}
      />
      <LayoutRoute path="/contracts-combined" component={CombinedDetails} />
      <LayoutRoute
        path="/contracts-disbursement-quote"
        component={CombinedContractDisbursementQuote}
      />
      <LayoutRoute
        path="/contracts-disbursement-quote-request"
        component={CombinedContractDisbursementQuoteRequest}
      />
      <LayoutRoute path="/customer/profile" component={CustomerProfile} />
      <LayoutRoute path="/document-upload/*" component={UploadPage} />
      <LayoutRoute path="/reports" component={Reports} />
      <LayoutRoute path="/library" component={Forms} />
      <LayoutRoute
        path="/on-demand-report-request"
        component={OnDemandReportRequest}
      />
      <LayoutRoute path="/unauthorized" component={Unauthorized} />
      <LayoutRoute path="/impersonate" component={ImpersonateUser} />
      <PrinterFriendlyLayoutRoute
        path="/contract-payment-history-print"
        component={PaymentHistory}
      />
      <PrinterFriendlyLayoutRoute
        path="/contracts/:number/for-print"
        component={ContractDetailsPrint}
      />
      <PrinterFriendlyConfirmationReceiptLayoutRoute
        path="/contracts/:number/confirmation-receipt"
        component={ConfirmationReceiptPrint}
      />
      <PrinterFriendlyConfirmationReceiptLayoutRoute
        path="/contracts/:number/purchaser-confirmation-receipt"
        component={ConfirmationReceiptPurchaserPrint}
      />
      <PrinterFriendlyConfirmationReceiptLayoutRoute
        path="/contracts/:number/coup-letter"
        component={CoupLetterPrint}
      />
      <PrinterFriendlyConfirmationReceiptLayoutRoute
        path="/contracts/:number/ssi-letter"
        component={SocialSecurityLetterPrint}
      />
      <PrinterFriendlyConfirmationReceiptLayoutRoute
        path="/contracts-combined-print"
        component={CombinedDetailsPrint}
      />
    </BrowserRouter>
  );
}

export default App;
